import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CustomText from "./text";

export default function ProgressHeader({
  label,
  progress = 0,
  size = 150,
  thickness = 5,
}) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const responsiveSize = isSmall ? 110 : size;

  const rawValue = Math.max(0, Math.min(100, Number(progress) || 0));
  const value = rawValue === 0 ? 0 : rawValue;

  const numberPart = label ? label.match(/[\d\u0660-\u0669]+/)?.[0] : "0";

  const textPart = label ? label.replace(/[\d\u0660-\u0669]+/, "").trim() : "";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        pt: 1,
        pb: 3,
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: responsiveSize,
          height: responsiveSize,
        }}
      >
        {/* Track */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={responsiveSize}
          thickness={thickness}
          sx={{
            color: "rgba(255, 255, 255, 0.2)",
            position: "absolute",
            left: 0,
            top: 0,
          }}
        />

        {/* Value */}
        <CircularProgress
          variant="determinate"
          value={value}
          size={responsiveSize}
          thickness={thickness}
          sx={{
            color: "#fff",
            position: "absolute",
            left: 0,
            top: 0,
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
        />

        {/* Center label */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {numberPart && (
            <CustomText
              customStyle={{
                fontWeight: 700,
                color: "#fff",
                lineHeight: 1,
              }}
              text={numberPart}
              type={isSmall ? "lg" : "xl"} 
            />
          )}

          <CustomText
            customStyle={{
              fontWeight: 500,
              color: "#fff",
              opacity: 0.9,
              mt: 0.5,
            }}
            text={textPart}
            type="xxs"
          />
        </Box>
      </Box>
    </Box>
  );
}
